import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyObserver } from '../../../observers/currency.observer';
import { BookLaunchOffer } from '../../../models/book_launch_offer.model';
import { BookPriceOffer } from '../../../models/vouchers/book_price_offer.model';

@Component({
  selector: 'app-book-launch-offer',
  templateUrl: './book-launch-offer.component.html',
  styleUrls: ['./book-launch-offer.component.scss']
})
export class BookLaunchOfferComponent implements OnInit {

  @Input() bookLaunchOffer: BookLaunchOffer | undefined;

  activeTier: BookPriceOffer | undefined

  countdownExpired = false

  constructor(
    public currencyObserver: CurrencyObserver
  ) {
  }

  ngOnInit(): void {
  }

  onCountdownDone(expired: boolean) {
    this.countdownExpired = expired
  }

  selectTier(activeTier: BookPriceOffer) {
    this.activeTier = activeTier
    this.bookLaunchOffer?.tiers.forEach(
      (tier) => tier.selected = activeTier === tier
    )
  }

}
